import cn from 'classnames';

import { trackContentfulClick, trackPromoBannerCTAClick } from '@libs/analytics';

import type { BannerProps } from './types';
import { getBannerDisplay } from './utils';

const ANALYTICS_VARIANT = {
    sm: 'Small',
    md: 'Medium',
    'md-alt': 'Category',
    lg: 'Large',
    xlg: 'Landing Page',
} as const;

export function trackBannerClick(banner: BannerProps, pathname: string | null) {
    const { size, title, cta } = banner;
    const display = getBannerDisplay(banner);
    const variant = size ? ANALYTICS_VARIANT[size] : '';

    trackPromoBannerCTAClick(title ?? '', variant, cta?.label ?? '');
    trackContentfulClick({
        linkText: cn(display.title, display.description, display.showCta && cta?.label),
        linkUrl: cta?.href ?? '',
        promoTitle: display.title,
        promoVariant: variant,
        promoOrigin: pathname,
        promoDesc: display.title,
        promoType: 'banner-container',
    });
}
